import Tippy from '@tippyjs/react';

import { mString } from 'lib/helpers/utility';
import numOrDefault from 'lib/helpers/numOrDefault';
import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';
import { LOCAL_DATETIME_FMT, formatDate } from 'lib/helpers/dateUtils';

import Icon from 'components/shared/Icon/Icon';
import Status from 'components/shared/Status/Status';
import CardProcessor from 'components/shared/CardProcessor';
import AmountPaidSelf from 'components/shared/Transactions/components/AmountPaidSelf';
import Actions from 'components/admin/pages/AdminIQueue/Transactions/components/Actions';

export const COLUMNS = [
  { field: 'id', headerName: 'ID', maxWidth: 100 },
  {
    field: 'created_at',
    headerName: 'Date',
    valueFormatter: ({ value }) => (value ? formatDate(value, null, LOCAL_DATETIME_FMT) : '-')
  },
  { field: 'practice_id', headerName: 'Practice ID' },
  { field: 'practice.name', headerName: 'Practice name', sortable: false },
  {
    field: 'patient_id',
    headerName: 'Patient ID',
    width: 300,
    valueFormatter: ({ value }) => (value ? value : '-')
  },
  {
    field: 'patient.fullName',
    headerName: 'Patient name',
    width: 300,
    valueFormatter: ({ value }) => (value ? value : '-'),
    sortable: false
  },
  {
    field: 'type',
    headerName: 'Type',
    valueFormatter: ({ value }) => (value ? TYPE_LABELS[value] : '-')
  },
  {
    field: 'cc_type',
    headerName: 'Card type',
    cellRenderer: ({ value }) => {
      return (
        <div className="flex h-full items-center justify-center">
          {value ? <CardProcessor>{value}</CardProcessor> : '-'}
        </div>
      );
    }
  },
  {
    field: 'cc_number_last_four',
    headerName: 'Card number (last 4)',
    valueFormatter: ({ value }) => (value ? value : '-'),
    sortable: false
  },
  {
    field: 'status',
    headerName: 'Status',
    cellRenderer: ({ value, data }) => {
      return (
        <div className="flex h-full items-center gap-2">
          {value ? <Status status={value} /> : '-'}
          {data?.status_description && (
            <Tippy
              className="tippy-dark"
              content={
                <span className="block max-w-[24rem] break-words">
                  {String(data?.status_description || '')}
                </span>
              }
              allowHTML={false}>
              <div aria-label="Status info">
                <Icon icon="info-mono" className="cursor-help" />
              </div>
            </Tippy>
          )}
        </div>
      );
    }
  },
  {
    field: 'amount_paid_self',
    headerName: 'Amount',
    initialWidth: 260,
    valueFormatter: ({ value, data }) => {
      let result = mString(numOrDefault(value) + (data?.amount_refunded ?? 0));
      if (data?.amount_refunded) {
        result += `(Refunded: -${mString(data.amount_refunded)})`;
      }
      return result;
    },
    cellRenderer: ({ value, data }) => {
      return <AmountPaidSelf value={value} data={data} />;
    },
    aggFunc: 'sum'
  },
  {
    field: 'cashier.fullName',
    headerName: 'Cashier',
    valueFormatter: ({ value }) => (value ? value : '-'),
    sortable: false
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: (params) => (
      <Actions
        data={{
          ...params.data,
          isPatient: true
        }}
      />
    ),
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right',
    no_show_csv: true
  }
];
